export enum HTMLTags {
  ANCHOR = 'a',
  PARAGRAPH = 'p',
  RICH_TEXT = 'p',
  HEADING_1 = 'h1',
  HEADING_2 = 'h2',
  HEADING_3 = 'h3',
  DIVIDER = 'hr',
  BREAK = 'br',
  BULLETED_LIST_ITEM = 'li',
  NUMBERED_LIST_ITEM = 'li',
  TOGGLE_ITEM = 'li',
  TO_DO_ITEM = 'label',
  BULLETED_LIST = 'ul',
  NUMBERED_LIST = 'ol',
  TO_DO = 'fieldset',
  TOGGLE = 'ul',
  IMAGE = 'img',
  CALLOUT = 'aside',
  QUOTE = 'blockquote',
}

export enum AnnotationTypes {
  BOLD = 'strong',
  CITE = 'cite',
  ITALIC = 'em',
  STRIKETHROUGH = 's',
  UNDERLINE = 'u',
  CODE = 'code',
}

export enum Color {
  DEFAULT = 'default',
  RED = 'red',
  BROWN = 'brown',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  TEAL = 'teal',
  BLUE = 'blue',
  PURPLE = 'purple',
  PINK = 'pink',
}
